import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

export const MainContainer = styled.div`
  display: flex;
  flex: 1;
  width: 80%;
`;
